import {IMainDb} from "../db/mainDb";
import {Game, Pitch, Player, TeamInfo, ThrowHand} from "../../models/utilTypes";
import {Position} from "../../models/position";
import {createId} from "../../models/util";
import {Firebase} from "../db/firebase";

export interface ITeamRepository {
  info(teamId: string): Promise<TeamInfo>;
  games(teamId: string): Promise<Game[]>;
  players(teamId: string): Promise<Player[]>;
  addPlayer(teamId: string, name: string, birth: string, position: Position[], throwHand: ThrowHand): Promise<Player>;
  updatePlayer(newPlayerData: Player, myTeamId: string): Promise<void>;
  deletePlayer(playerId: string, myTeamId: string): Promise<void>;
  addGame(teamId: string, vsTeam: string, dateTime: string, pitches: Pitch[]): Promise<Game>;
  updateGame(newGameInfo: Game, myTeamId: string): Promise<void>;
  deleteGame(gameId: string, myTeamId: string): Promise<void>;
  getAll():Promise<void>;
}

export class TeamRepository implements ITeamRepository {

  private static _instance: TeamRepository;
  private readonly mainDb: IMainDb

  private constructor() {
    this.mainDb = Firebase.instance as IMainDb;
  }

  static get instance() {
    if(!this._instance) {
      this._instance = new TeamRepository();
    }
    return this._instance;
  }

  async info(teamId: string): Promise<TeamInfo> {
    return await this.mainDb.getTeamInfo(teamId);
  }

  async games(teamId: string): Promise<Game[]> {
    return await this.mainDb.getTeamGames(teamId);
  }

  async players(teamId: string): Promise<Player[]> {
    return await this.mainDb.getTeamPlayers(teamId);
  }

  async addPlayer(teamId: string, name: string, birth: string, position: Position[], throwHand: ThrowHand): Promise<Player> {
    const playerId = 'p_' + createId();
    return await this.mainDb.addPlayer(playerId, name, birth, position, throwHand, teamId)
  }

  async updatePlayer(newPlayerData: Player, myTeamId: string): Promise<void> {
    await this.mainDb.updatePlayer(newPlayerData.id, newPlayerData.name, newPlayerData.birth, newPlayerData.position, newPlayerData.throwHand, myTeamId);
  }

  async deletePlayer(playerId: string, myTeamId: string): Promise<void> {
    await this.mainDb.deletePlayer(playerId, myTeamId);
  }

  async addGame(teamId: string, vsTeam: string, dateTime: string, pitches: Pitch[]): Promise<Game> {
    const gameId = 'g_' + createId();
    return await this.mainDb.addGame(gameId, vsTeam, dateTime, pitches, teamId);
  }

  async updateGame(newGameInfo: Game, myTeamId: string): Promise<void> {
    await this.mainDb.updateGame(newGameInfo.id, newGameInfo.vsTeam, newGameInfo.dateTime, newGameInfo.pitches, myTeamId);
  }

  async deleteGame(gameId: string, myTeamId: string): Promise<void> {
    await this.mainDb.deleteGame(gameId, myTeamId);
  }
  
  async getAll(){
    await this.mainDb.getAll();
  }
}
